<template>
    <div class="member-enrollment">
        <Signup v-if="showRegistration"
            name="member_enrollment"
            @completed="onRegistrationCompleted"
        />

        <Verification v-if="showVerification"
            @completed="onVerificationCompleted"
        />
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import Signup from '@/components/form/member-enrollment/Signup.vue';
import Verification from '@/components/form/member-enrollment/Verification.vue';
import { useInjectedApplicationSettings } from '@/composables/useApplicationSettingsProvider.js';

defineProps({
    name: { type: String, required: true },
});

const emit = defineEmits(["update:model-value", "input", "goToNextStep"]);

const applicationSettings = useInjectedApplicationSettings();

const phase = ref('registration'); // 'registration' | 'verification' | 'done'

const showRegistration = computed(() => phase.value === 'registration');
const showVerification = computed(() => phase.value === 'verification');

onMounted(() => {
    if (applicationSettings.isUserRegistered) {
        emit('goToNextStep');
    }
});

function onRegistrationCompleted() {
    if (applicationSettings.userWantsVerification) {
        phase.value = 'verification';
    } else {
        emit('goToNextStep');
    }
}

function onVerificationCompleted() {
    applicationSettings.isUserVerified = true;
    emit('goToNextStep');
}

// Verification.skipVerification() signals skip via this setting, not via emit
watch(() => applicationSettings.userWantsVerification, (newVal) => {
    if (newVal === false && phase.value === 'verification') {
        emit('goToNextStep');
    }
});
</script>

<style scoped>
.member-enrollment {
    margin-bottom: -1rem;
}
</style>
